import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";

//Design imports
import Grid from "@mui/material/Grid2";

//Component imports
import AlarmListTable from "./monitoringList.jsx";

//Localization Imports
import { useDispatch, useSelector } from "react-redux";
import {
  currentAlarmSelector,
  filteredAlarmSelector,
  setCurrentAlarmLoading,
  getSearchButtonSelector,
} from "../../../model/slice/alarmSlice.js";
import { fetchCurrentAlarm } from "../../../model/async/alarmAsync.js";
import { getComparator } from "../utils/helper.js";
import constants from "../utils/constants.js";
import { FETCH_INTERVAL } from "../../../constants/constants.js";

const AlarmPanel = React.memo((props) => {
  const { height } = props;
  const vesselId = props.vesselId;
  const filteredCurrentAlarmList = useSelector(filteredAlarmSelector);
  const currentAlarmList = useSelector(currentAlarmSelector);
  const searchButtonFlag = useSelector(getSearchButtonSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCurrentAlarm({ vesselId }))
    const interval = setInterval(() => dispatch(fetchCurrentAlarm({ vesselId })), FETCH_INTERVAL);
    dispatch(setCurrentAlarmLoading(true));

    return () => {
      clearInterval(interval);
    }
  }, []);

  const filterList = useMemo(() => {
    let arrayForSort;
    if (searchButtonFlag) {
      arrayForSort = [...filteredCurrentAlarmList];
    } else {
      arrayForSort = [...currentAlarmList];
    }
    return arrayForSort.sort(getComparator("asc", constants.ALARM_HEADER_ID.OCCURRENCE));
  }, [searchButtonFlag, currentAlarmList, filteredCurrentAlarmList]);

  return (
    <Grid
      container
      alignItems="stretch"
      style={{ display: "flex", overflowX: "hidden" }}
      justifyContent="center"
    >
        <Grid item size={{xs:12}}>
          <AlarmListTable alarmList={filterList} vesselId={vesselId} height={height} />
        </Grid>
      </Grid>
  );
});

AlarmPanel.propTypes = {
  vesselName: PropTypes.string,
  vesselId: PropTypes.string,
  height: PropTypes.number,
};

export default AlarmPanel;
